export default "__VITE_ASSET__eTObpJpN__"